(function () {
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeJsonParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function getTone(meta) {
    if (!meta || !meta.tone) return 'neutral';
    return meta.tone;
  }

  function getLabel(meta, fallback) {
    if (!meta || !meta.label) return fallback || '';
    return meta.label || '';
  }

  function formatDelta(diff) {
    if (diff == null || !Number.isFinite(diff)) return '';
    if (Math.abs(diff) <= 0.25) return 'matches';
    return (diff > 0 ? '+' : '') + diff.toFixed(2) + '"';
  }

  function cleanLabel(label) {
    return String(label || '')
      .replace(/\bnotably\b/gi, '')
      .replace(/\bslightly\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function buildBadge(label, meta, diff, extraClass) {
    if (!meta) return '';

    var delta = formatDelta(diff);
    var cleanedLabel = cleanLabel(getLabel(meta));
    var value = '';

    if (delta === 'matches') {
      value = 'matches';
    } else if (delta) {
      value = delta + ' ' + cleanedLabel;
    } else {
      value = cleanedLabel;
    }

    return ''
      + '<div class="nfd-size-rec-visual-badge nfd-size-rec-visual-badge--' + escapeHtml(getTone(meta)) + (extraClass ? ' ' + extraClass : '') + '">'
      +   '<span class="nfd-size-rec-visual-badge__label">' + escapeHtml(label) + '</span>'
      +   '<span class="nfd-size-rec-visual-badge__value">' + escapeHtml(value) + '</span>'
      + '</div>';
  }

  function buildLineClass(baseClass, meta) {
    return baseClass + ' ' + getTone(meta);
  }

  function normalizePoint(val, fallback) {
    var n = Number(val);
    return Number.isFinite(n) ? n : fallback;
  }

  function toPercent(n) {
    return (n * 100) + '%';
  }

  function normalizeMeasureKey(key) {
    return String(key || '')
      .trim()
      .toLowerCase()
      .replace(/_/g, '-')
      .replace(/\s+/g, '-');
  }

  function normalizeOverlayMap(map) {
    var out = {};
    if (!map || typeof map !== 'object') return out;

    Object.keys(map).forEach(function (key) {
      out[normalizeMeasureKey(key)] = map[key];
    });

    return out;
  }

  function getFitVisualData() {
    var scriptEl = document.getElementById('nfd-fit-visual-data');
    if (!scriptEl) return null;

    var raw = scriptEl.textContent || scriptEl.innerText || '';
    var parsed = safeJsonParse(raw, null);
    if (!parsed || typeof parsed !== 'object') return null;

    var guides = parsed.guides_json;
    var badges = parsed.badges_json;

    if (typeof guides === 'string') {
      guides = safeJsonParse(guides, {});
    }

    if (typeof badges === 'string') {
      badges = safeJsonParse(badges, {});
    }

    return {
      category: parsed.category || '',
      drawing: parsed.drawing || '',
      guides: normalizeOverlayMap(guides),
      badges: normalizeOverlayMap(badges)
    };
  }

  function getMeasureMeta(result, mode, key) {
    var reasons = result && result.reasons ? result.reasons : {};
    var fit = result && result.fitComparison ? result.fitComparison : {};

    if (mode === 'tops') {
      if (key === 'shoulder') return reasons.shoulder || null;
      if (key === 'pit') return reasons.pitToPit || null;
      if (key === 'sleeve') return reasons.sleeveLength || null;
      if (key === 'body') return fit.bodyLength && fit.bodyLength.meta ? fit.bodyLength.meta : null;
      return null;
    }

    if (key === 'waist') return reasons.waist || null;
    if (key === 'upper-thigh') return reasons.upperThigh || null;
    if (key === 'rise') return fit.frontRise && fit.frontRise.meta ? fit.frontRise.meta : null;
    if (key === 'knee') return fit.knee && fit.knee.meta ? fit.knee.meta : null;
    if (key === 'leg-opening') return fit.legOpening && fit.legOpening.meta ? fit.legOpening.meta : null;
    if (key === 'inseam') return fit.inseam && fit.inseam.meta ? fit.inseam.meta : null;

    return null;
  }

  function getBadgeDiff(result, mode, key) {
    var user = result && result.measurements && result.measurements.user ? result.measurements.user : {};
    var product = result && result.measurements && result.measurements.product ? result.measurements.product : {};

    if (mode === 'tops') {
      if (key === 'shoulder' && product.shoulder != null && user.shoulder != null) return product.shoulder - user.shoulder;
      if (key === 'pit' && product.pitToPit != null && user.pitToPit != null) return product.pitToPit - user.pitToPit;
      if (key === 'sleeve' && product.sleeveLength != null && user.sleeveLength != null) return product.sleeveLength - user.sleeveLength;
      if (key === 'body' && product.bodyLength != null && user.bodyLength != null) return product.bodyLength - user.bodyLength;
      return null;
    }

    if (key === 'waist' && product.waist != null && user.waist != null) return product.waist - user.waist;
    if (key === 'upper-thigh' && product.upperThigh != null && user.upperThigh != null) return product.upperThigh - user.upperThigh;
    if (key === 'rise' && product.frontRise != null && user.frontRise != null) return product.frontRise - user.frontRise;
    if (key === 'knee' && product.knee != null && user.knee != null) return product.knee - user.knee;
    if (key === 'leg-opening' && product.legOpening != null && user.legOpening != null) return product.legOpening - user.legOpening;
    if (key === 'inseam' && product.inseam != null && user.inseam != null) return product.inseam - user.inseam;

    return null;
  }

  function getBadgeTitle(key) {
    var map = {
      waist: 'Waist',
      'upper-thigh': 'Upper thigh',
      rise: 'Rise',
      knee: 'Knee',
      'leg-opening': 'Opening',
      inseam: 'Inseam',
      shoulder: 'Shoulder',
      pit: 'Pit to pit',
      sleeve: 'Sleeve',
      body: 'Body'
    };
    return map[key] || key;
  }

  function hasMeasure(result, mode, key) {
    return !!getMeasureMeta(result, mode, key);
  }

function buildGuideHtml(key, config, meta) {
  if (!config) return '';

  var axis = String(config.axis || '').toLowerCase();
  var x1 = normalizePoint(config.x1, 0);
  var y1 = normalizePoint(config.y1, 0);
  var x2 = normalizePoint(config.x2, 0);
  var y2 = normalizePoint(config.y2, 0);

  var className = escapeHtml(buildLineClass('nfd-size-rec-visual-guide', meta));
  var style = '';

  if (axis === 'vertical') {
    var top = Math.min(y1, y2);
    var height = Math.abs(y2 - y1);

    style =
      'left:' + (x1 * 100) + '%;' +
      'top:' + (top * 100) + '%;' +
      'height:' + (height * 100) + '%;';

    return ''
      + '<div'
      + ' class="' + className + ' nfd-size-rec-visual-guide--vertical"'
      + ' data-measure="' + escapeHtml(key) + '"'
      + ' style="' + style + '"'
      + '></div>';
  }

  if (axis === 'horizontal') {
    var left = Math.min(x1, x2);
    var width = Math.abs(x2 - x1);

    style =
      'left:' + (left * 100) + '%;' +
      'top:' + (y1 * 100) + '%;' +
      'width:' + (width * 100) + '%;';

    return ''
      + '<div'
      + ' class="' + className + ' nfd-size-rec-visual-guide--horizontal"'
      + ' data-measure="' + escapeHtml(key) + '"'
      + ' style="' + style + '"'
      + '></div>';
  }

  var dx = x2 - x1;
  var dy = y2 - y1;
  var length = Math.sqrt(dx * dx + dy * dy);
  var angle = Math.atan2(dy, dx) * 180 / Math.PI;

  style =
    'left:' + (x1 * 100) + '%;' +
    'top:' + (y1 * 100) + '%;' +
    'width:' + (length * 100) + '%;' +
    'transform:translateY(-50%) rotate(' + angle + 'deg);';

  return ''
    + '<div'
    + ' class="' + className + ' nfd-size-rec-visual-guide--angled"'
    + ' data-measure="' + escapeHtml(key) + '"'
    + ' style="' + style + '"'
    + '></div>';
}
  function buildBadgeHtml(key, config, result, mode, extraClass) {
    if (!config) return '';

    var meta = getMeasureMeta(result, mode, key);
    if (!meta) return '';

    var label = getBadgeTitle(key);
    var diff = getBadgeDiff(result, mode, key);

    var x = normalizePoint(config.x, 0);
    var y = normalizePoint(config.y, 0);
    var align = String(config.align || 'left').toLowerCase();
    var alignClass = 'nfd-size-rec-visual-point--align-' + align;

    return ''
      + '<div'
      + ' class="nfd-size-rec-visual-point ' + alignClass + '"'
      + ' data-measure="' + escapeHtml(key) + '"'
      + ' style="left:' + toPercent(x) + ';top:' + toPercent(y) + ';"'
      + '>'
      + buildBadge(label, meta, diff, extraClass)
      + '</div>';
  }

  function buildVisualMap(result, options) {
    options = options || {};
    var mode = options.mode || 'bottoms';
    var fitData = getFitVisualData();

    if (!fitData || !fitData.drawing) {
      return '';
    }

    var guideKeys = mode === 'tops'
      ? ['shoulder', 'pit', 'sleeve', 'body']
      : ['waist', 'upper-thigh', 'rise', 'knee', 'leg-opening', 'inseam'];

    var guideHtml = '';
    var badgeHtml = '';

    guideKeys.forEach(function (key) {
      if (!hasMeasure(result, mode, key)) return;

      guideHtml += buildGuideHtml(
        key,
        fitData.guides && fitData.guides[key] ? fitData.guides[key] : null,
        getMeasureMeta(result, mode, key)
      );

      badgeHtml += buildBadgeHtml(
        key,
        fitData.badges && fitData.badges[key] ? fitData.badges[key] : null,
        result,
        mode,
        (key === 'rise' || key === 'knee' || key === 'leg-opening' || key === 'inseam' || key === 'body')
          ? 'nfd-size-rec-visual-badge--secondary'
          : ''
      );
    });

   return ''
  + '<div class="nfd-size-rec-visual nfd-size-rec-visual--' + escapeHtml(mode) + '">'
  +   '<div class="nfd-size-rec-visual-stage">'
  +     '<div class="nfd-size-rec-visual-drawing-wrap">'
  +       '<img class="nfd-size-rec-visual-image" src="' + escapeHtml(fitData.drawing) + '" alt="" loading="lazy">'
  +     '</div>'
  +     '<div class="nfd-size-rec-visual-guides-layer">' + guideHtml + '</div>'
  +     '<div class="nfd-size-rec-visual-badges-layer">' + badgeHtml + '</div>'
  +     '<div class="nfd-size-rec-visual-hint-badge">Hover a label to highlight details.</div>'
  +   '</div>'
  + '</div>';
  }

  function build(result, options) {
    if (!result) return '';
    return buildVisualMap(result, options || {});
  }

  function bindVisualHover(rootEl) {
    if (!rootEl) return;

    var all = rootEl.querySelectorAll('[data-measure]');

    function setActive(key, active) {
      if (!key) return;

      rootEl.classList.toggle('is-hovering', active);

      rootEl.querySelectorAll('[data-measure]').forEach(function (el) {
        el.classList.toggle('is-active', active && el.getAttribute('data-measure') === key);
      });
    }

    all.forEach(function (el) {
      var key = el.getAttribute('data-measure');
      if (!key) return;

      el.addEventListener('mouseenter', function () {
        setActive(key, true);
      });

      el.addEventListener('mouseleave', function () {
        setActive(key, false);
      });

      el.addEventListener('focusin', function () {
        setActive(key, true);
      });

      el.addEventListener('focusout', function () {
        setActive(key, false);
      });
    });
  }

  function mount(rootEl, result, options) {
    options = options || {};

    if (!rootEl) return;

    rootEl.innerHTML = build(result, options);
    bindVisualHover(rootEl);
  }

  window.NFDSizeVisual = {
    build: build,
    mount: mount,
    getFitVisualData: getFitVisualData
  };
})();